import * as React from 'react';
import { GridView } from './../serversm/grideView';
import { ListView } from './../serversm/listView';
import { FileInformation } from './../serversm/fileinformation';
import { BreadcrumbComponent } from './../serversm/breadcrum';
import { DeleteDialog, EditDialog } from './../serversm/dialogue';
import { serverData } from './../serversm/data';
import SettingServerSM from "../../services/settingServerSM";
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { OPERATIONSTATUS } from '../../shared/appcomponents/enums';

import {
  formatData,
  getFolderTree,
  searchTreeItem,
  addDataItem,
  addFolder,
  convertExtensionToIcon,
  convertToBreadcrumbData,
  removeDataItem,
  editDataItem,
  getFolderPath,
  getName,
  removeHomePrefix
} from './../serversm/helper';
import { ContextMenu } from './../serversm/contextmenu';
import '@progress/kendo-theme-default/dist/all.css';
import { Splitter, SplitterOnChangeEvent, BreadcrumbLinkMouseEvent } from '@progress/kendo-react-layout';
import { useInternationalization } from '@progress/kendo-react-intl';
import { process, SortDescriptor } from '@progress/kendo-data-query';
import { clone, getter } from '@progress/kendo-react-common';
import { GridRowDoubleClickEvent, GridRowClickEvent, getSelectedState } from '@progress/kendo-react-grid';
import { UploadFileInfo } from '@progress/kendo-react-upload';
import { TreeViewItemClickEvent } from '@progress/kendo-react-treeview';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { Offset } from '@progress/kendo-react-popup';
import { Card, CardHeader, CardBody, Button, Input, Form, FormInput, FormDropdown, FormCheckbox, Loader, EditIcon, TrashCanIcon, Alert, Checkbox, Dialog as FluentDialog, Tooltip, Status , Text} from '@fluentui/react-northstar';
import { FileManagerToolbar } from './../serversm/fileManagerToolbar';;


const splitterPanes = [
  {
    size: '70%',
    min: '20px',
    collapsible: true,
  },
  {},
  {
    size: '30%',
    min: '20px',
    collapsible: true,
  },
];

const initialSort = [{
  field: 'path',
  dir: 'asc'
}];

const DATA_ITEM_KEY = 'path';
const SELECTED_FIELD = 'selected';
const idGetter = getter(DATA_ITEM_KEY);

const FileManager = (props) => {
  const intl = useInternationalization();
  const [isLoaded, SetLoaded] = React.useState(false);
  const[isEditorVisible, setIsEditorVisible] = React.useState(false);
  const [stateData, setStateData] = React.useState([]);
  const [panes, setPanes] = React.useState(splitterPanes);

  const [selectedGridItem, setSelectedGridItem] = React.useState({});
  const [selectedTreeItem, setSelectedTreeItem] = React.useState(null);
  const [gridSelection, setGridSelection] = React.useState({});

  const [detailsData, setDetailsData] = React.useState(null);
  const [files, setFiles] = React.useState([]);
  const [contentView, setContentView] = React.useState('grid');
  const [contextMenuView, setContextMenuView] = React.useState(false);
  const [menuOffSet, setMenuOffSet] = React.useState({ left: 0, top: 0 });
  const [editDialogView, setEditDialogView] = React.useState(false);
  const [deleteDialogView, setDeleteDialogView] = React.useState(false);
  const [visibleAddFolder, setVisibleAddFolder] = React.useState(false);
  const [newFolderName, SetNewFolderName] = React.useState(null);
  const [isValidFileName, setIsValidFileName] = React.useState(false);

  const splitBtnItems = [
    { text: 'Name', value: 'path' },
    { text: 'File Size', value: 'size' },
    { text: 'Date Created', value: 'dateCreated' }
  ];

  const initialLogic= 'and';

  const [stateContentData, setStateContentData] = React.useState({
    sort: initialSort,
    filter: {
      logic: initialLogic,
      filters: [
        { field: 'path', operator: 'contains', value: '' }
      ]
    }
  });

  React.useEffect(() => {

    props.acquireToken(authSuccessCallback);
 }, []);

 const authSuccessCallback = (token) => {
  var data = props.serverObj;
  let serverObj = { IPAddress: data.IPAddress, Port: data.Port, Path : "" };

  if (token) {
    SettingServerSM.GetServerFolders(serverObj, token).then((response) => {
      if (response && response.status == 200) {
        let foldersFound = response.data.FolderData;
        //setVMData(process(response.data, dataState));
        let listFolders =  [];
        for(let i = 0; i < foldersFound.length; i++)
        {
          let folderPath = "Home/" + (foldersFound[i]?.Name?.trim());
          var fileObj = {path : folderPath, size : foldersFound[i].Size, dateModified : new Date (foldersFound[i].mDate), dateCreated : new Date(), isFolder : foldersFound[i]?.isFolder };
          listFolders.push(fileObj);
        }

        setStateData(formatData(listFolders, intl));
      }
      else if (response && response.status == 401) {
        props.viewStatus.InformChildPageStatus(response.status);
      }
      else {
        props.viewStatus.InformChildPageStatus(500);
      }
      SetLoaded(true);
    });
  }
};

React.useEffect(() => checkIsValid(), [newFolderName]);

const checkIsValid = () => {
  if (
    newFolderName!== undefined  &&
    newFolderName?.length > 0        
  ) 
  {
    setIsValidFileName(true);
  } else setIsValidFileName(false);
};

  const updateFileDetailsData = React.useCallback(
    (selection) => {
      if (selection.path) {
        const newSelectedItem = searchTreeItem(stateData, selection)
        setDetailsData(newSelectedItem);
      } else if (!selection.path && Object.keys(selection).length) {
        setDetailsData(Object.keys(selection).length);
      }
      else {
        setDetailsData(null);
      }
    },
    [stateData]
  );

  const handleTreeItemClick = (event) => {
    const newSelectedItem = searchTreeItem(stateData, event.item);
    newSelectedItem.expanded = !event.item.expanded;

    setSelectedTreeItem(newSelectedItem);
    setDetailsData(event.item);
    setSelectedGridItem({});
    setGridSelection({});
  };

  const handleSplitterChange = (event) => {
    setPanes(event.newState);
  };

  const handleSelectionChange = (event) => {
    setSelectedGridItem(event.dataItem);
    updateFileDetailsData(event.dataItem);
    if (event.dataItem.path) {
      const key = event.dataItem['path'].toString();
      setGridSelection({ [key]: true });
    }
  };

  const handleMultipleSelection = (event) => {
    const newSelection = getSelectedState({
      event,
      selectedState: gridSelection,
      dataItemKey: DATA_ITEM_KEY
    });

    setGridSelection(newSelection);
    updateFileDetailsData(newSelection);
  }

  const handleSortChange = (event) => {
    const newSortedData = clone(stateContentData);

    if (event.direction === 'asc' || event.direction === 'desc') {
      newSortedData.sort[0].dir = event.direction;
    }

    if (event.item) {
      newSortedData.sort[0].field = event.item.value;
    }

    if (event.sort) {
      newSortedData.sort = event.sort;
    }
    setStateContentData(newSortedData);
  };

  const handleDownloadClick = (data) => {
    debugger;
    let selectedFileObj = data;

    props.acquireToken((token) => {
      var data = props.serverObj;
      let fileName = getName(selectedFileObj.path);
      let folderName = getFolderPath(selectedFileObj.path);

      let serverObj = { IPAddress: data.IPAddress, Port: data.Port, Path : removeHomePrefix(folderName), FileName : fileName};

      debugger;

      if (token) {
        SettingServerSM.ReadFile(token, serverObj).then((response) => {
          if (response && response.status == 200) {
              // 2. Create blob link to download
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', fileName);
              // 3. Append to html page
              document.body.appendChild(link);
              // 4. Force download
              link.click();
              // 5. Clean up and remove the link
              link.parentNode.removeChild(link);
        }
          else if (response && response.status == 401) {
            props.viewStatus.InformChildPageStatus(response.status);
          }
          else {
            props.viewStatus.InformChildPageStatus(500);
          }
          SetLoaded(true);
        });
      }
    });
  };

  const handleGridDoubleClick = (event) => {
    debugger;
    let selectedFolderObj = event.dataItem;
    var foundTreeItem = searchTreeItem(stateData, event.dataItem);
    foundTreeItem.items = [];
    props.acquireToken((token) => {
      var data = props.serverObj;
      let serverObj = { IPAddress: data.IPAddress, Port: data.Port, Path : removeHomePrefix(selectedFolderObj.path)};
      if (token) {
        SettingServerSM.GetServerFolders(serverObj, token).then((response) => {
          if (response && response.status == 200) {
            let foldersFound = response.data.FolderData;
            //setVMData(process(response.data, dataState));
            let listFolders =  [];
            for(let i = 0; i < foldersFound.length; i++)
            {
              var fileObj = {path : selectedFolderObj.path + "/" + foldersFound[i].Name?.trim(), size : foldersFound[i].Size, dateModified : new Date (foldersFound[i].mDate), dateCreated : new Date() , isFolder : foldersFound[i]?.isFolder};
              foundTreeItem.items.push(fileObj);
              listFolders.push(fileObj);
            }
            setStateData(formatData(stateData, intl));

            const itemType = convertExtensionToIcon(event.dataItem.path);
            if (itemType?.type === 'Folder') {
              if (selectedTreeItem) {
                selectedTreeItem.expanded = true;
              }
        
              const newSelectedItem = event.dataItem;
              newSelectedItem.expanded = true;
              setSelectedTreeItem(searchTreeItem(stateData, newSelectedItem));
            }
        }
          else if (response && response.status == 401) {
            props.viewStatus.InformChildPageStatus(response.status);
          }
          else {
            props.viewStatus.InformChildPageStatus(500);
          }
          SetLoaded(true);
        });
      }
    });
  };

  const handleNewFolderClick = (event) => {
    setVisibleAddFolder(true);    
  };

  const handleSearchChange = (event) => {
    let eventPath = '';
    if (selectedTreeItem?.items) {
      const curPath = getFolderPath(selectedTreeItem.items[0].path);
      eventPath = `${curPath}/${event.value}`;
    } else {
      const curPath = getFolderPath(stateData[0].path);
      eventPath = `${curPath}/${event.value}`;
    }

    setStateContentData({
      ...stateContentData,
      filter: {
        logic: initialLogic,
        filters: [
          { field: 'path', operator: 'contains', value: eventPath }
        ]
      }
    });
  };

  const handleSwitchChange = (event) => {
    const newPanes = panes.slice(0)
    if (event.value) {
      newPanes[2].size = '30%';
      setPanes(newPanes)
    } else {
      newPanes[2].size = '0%';
      setPanes(newPanes)
    }
  };

  const handleViewChange = (event) => {
    if (event.viewValue.gridView) {
      setContentView('grid');
    }
    if (event.viewValue.listView) {
      setContentView('list');
    }
  };

  const handleFileChange = (event) => {
    if (event.files) {
      setFiles(event.files);
    }
  };

  const handleClearFileList = (event) => {
    if (event) {
      setFiles([]);
    }
  };

  const handleUploadComplete = (event) => {
    debugger;
    let selectedObj = selectedTreeItem;
    files
    .filter((file) => !file.validationErrors)
    .forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = (ev) => {
        let fileReadData = ev.target.result;

        props.acquireToken((token) => {
          var data = props.serverObj;
          let serverObj = { IPAddress: props.serverObj.IPAddress, Port: props.serverObj.Port, Path : removeHomePrefix(selectedObj.path), FileName : file.name, FileData : fileReadData};
          if (token) {
            SettingServerSM.UploadFile(token, serverObj).then((response) => {
              if (response && response.status == 200) {
                setStateData(newData);
            }
              else if (response && response.status == 401) {
                props.viewStatus.InformChildPageStatus(response.status);
              }
              else {
                props.viewStatus.InformChildPageStatus(500);
              }
              SetLoaded(true);
            });
          }
        });

      };
      if (file && file.getRawFile) {
        reader.readAsDataURL(file.getRawFile());
      }
    });

    const newData = addDataItem(stateData, selectedTreeItem, files, intl);

    setStateData(newData);
    setFiles([]);
  };


  const handleBreadcrumbSelection = (event) => {
    setSelectedGridItem({});
    setGridSelection({});

    if (!event.nativeEvent.keyCode) {
      const newItem = searchTreeItem(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
    }

    if (event.nativeEvent.keyCode === 13) {
      const newItem = searchTreeItem(stateData, { path: event.id });
      setSelectedTreeItem(newItem);
    }
  };

  const handleDialogClick = (event) => {
    if (event.type === 'cancel') {
      setDeleteDialogView(false);
      setEditDialogView(false);
    }

    const curItem =  Object.keys(selectedGridItem).length ? selectedGridItem : selectedTreeItem;
    if (!curItem) { return; }

    if (event.type === 'delete') {
      const newItem = curItem.path || '';
      const oldPath = newItem.split('/');

      oldPath.pop();

      const updatedData = removeDataItem(stateData, curItem);
      let newItemPath = oldPath.join('/');

      setSelectedTreeItem(searchTreeItem(updatedData, { path: newItemPath }));
      setStateData(updatedData);
      setDeleteDialogView(false);
    }

    if (event.type === 'rename') {
      const folderPath = getFolderPath(event.path);
      const newPath = `${folderPath}/${event.value}`

      const existingItem = searchTreeItem(stateData, { path: newPath });
      if (!existingItem) {
        const updatedData = editDataItem(stateData, curItem, newPath);
        setSelectedTreeItem(searchTreeItem(updatedData, { path: newPath }))
        setStateData(updatedData);
      }
      setEditDialogView(false);
    }
  };

  const handleListItemClick = (event) => {
    let newSelectedGridItem = {};
    if (event.dataItem.path) {
      newSelectedGridItem = event.dataItem;
      newSelectedGridItem[event.dataItem.path] = true;
      newSelectedGridItem['selected'] = true;

      setSelectedGridItem(newSelectedGridItem);
      if (event.dataItem.path) {
        const key = event.dataItem.path.toString();
        setGridSelection({ [key]: true });
      }

    }

    if (event.tree) {
      const newSelectedTreeItem = searchTreeItem(stateData, newSelectedGridItem);
      setSelectedTreeItem(newSelectedTreeItem);
    }
    updateFileDetailsData(newSelectedGridItem);
  };


  const handleContextMenuView = (event) => {
    setContextMenuView(true);
    setMenuOffSet({ left: event.event.clientX, top: event.event.clientY });
    handleListItemClick(event);
  };

  const handleContextMenuClick = (event) => {
    if (event.itemId === '0') {
      setEditDialogView(true);
    } else {
      setDeleteDialogView(true);
    }
  };

  const handleDialogClose = () => {
    setDeleteDialogView(false);
    setEditDialogView(false);
  };

  document.addEventListener('click', () => {
    setContextMenuView(false);
  });

  
  const submitHandler = e => {
    e.preventDefault();
  }

  const handleAddNewFolderClickClose = () => {
    setVisibleAddFolder(false);
    setIsValidFileName(false);
    SetNewFolderName(null);
  };

  const addNewFolderSubmitClickHandler = () => {
    props.acquireToken(authSuccessNewFolderBindingCallback);
    setVisibleAddFolder(false);
    SetNewFolderName(null);
  };

  const authSuccessNewFolderBindingCallback = (token) => {
    debugger;
    let _params = {
      IPAddress : props?.serverObj?.IPAddress,
      Port : props?.serverObj?.Port,
      FolderName : newFolderName,
      Path :  removeHomePrefix(selectedTreeItem?.path)
    };

    if (token) {
      SettingServerSM.AddNewFolder(token, _params).then((response) => {
        if(response && response.status==200){
          response=response.data;          
        props.acquireToken(authSuccessCallback);
        props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Success);
      }
      else if(response && response.status==401){
        props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Unauthorized);
      }
      else{
        props.viewStatus.DisplayOperationStatus(OPERATIONSTATUS.Failed);
      }
    });
    }
  };

  return (
    <div className='k-widget k-filemanager k-filemanager-resizable' style={{height: '100%'}}>
      <div className='k-filemanager-header'>
        <FileManagerToolbar
          splitItems={splitBtnItems}
          sort={stateContentData.sort}
          files={files}
          {...props}
          onNewFolderClick={handleNewFolderClick}
          onSearchChange={handleSearchChange}
          onSwitchChange={handleSwitchChange}
          onViewChange={handleViewChange}
          onSortChange={handleSortChange}

          onFileChange={handleFileChange}
          onClearFileList={handleClearFileList}
          onUploadComplete={handleUploadComplete}
        />
      </div>
      <div className='k-filemanager-content-container'>
        <Splitter
          panes={panes}
          onChange={handleSplitterChange}
        >

          <div className='k-filemanager-content' style={{ textAlign: "left", height: "100%" }}>
            <BreadcrumbComponent
              data={convertToBreadcrumbData(selectedTreeItem)}
              onBreadcrumbSelect={handleBreadcrumbSelection}
            />
            {contentView === 'grid'
              ? <GridView
                data={selectedTreeItem && selectedTreeItem.items
                  ? process((selectedTreeItem.items.map(item => ({
                    ...item,
                    [SELECTED_FIELD]: gridSelection[idGetter(item)],
                  })))
                    , stateContentData)
                  : !selectedTreeItem
                    ? process((stateData.map(item => ({
                      ...item,
                      [SELECTED_FIELD]: gridSelection[idGetter(item)],
                    })))
                      , stateContentData)
                    : null
                }

                {...props}
                handleDownloadClick = {handleDownloadClick}
                sort={stateContentData.sort}
                dataItemKey={DATA_ITEM_KEY}
                onSelectionChange={handleSelectionChange}
                onMultipleSelection={handleMultipleSelection}
                onSortChange={handleSortChange}
                onDoubleClick={handleGridDoubleClick}
                onContextMenu={handleContextMenuView}
              />
              : <ListView
                data={selectedTreeItem && selectedTreeItem.items
                  ? process((selectedTreeItem.items.map(item => ({
                    ...item,
                    [SELECTED_FIELD]: gridSelection[idGetter(item)],
                  })))
                    , stateContentData)
                  : !selectedTreeItem
                    ? process((stateData.map(item => ({
                      ...item,
                      [SELECTED_FIELD]: gridSelection[idGetter(item)],
                    })))
                      , stateContentData)
                    : null
                }
                onSelectionChange={handleSelectionChange}
                onMultipleSelection={handleMultipleSelection}
                onItemClick={handleListItemClick}
                onDoubleClick={handleGridDoubleClick}
                onContextMenu={handleContextMenuView}
              />
            }
            {contextMenuView ? <ContextMenu offset={menuOffSet} onContextMenuCLick={handleContextMenuClick} /> : ''}
            {editDialogView
              ? <EditDialog
                editValue={Object.keys(selectedGridItem).length ? selectedGridItem : selectedTreeItem}
                onDialogClose={handleDialogClose}
                onDialogClick={handleDialogClick}
              />
              : ''}
            {deleteDialogView ? <DeleteDialog onDialogClose={handleDialogClose} onDialogClick={handleDialogClick} /> : ''}
          </div>
          <FileInformation  data={detailsData}/>
        </Splitter>
      </div>

      <div>
                    {visibleAddFolder && (
                      <Dialog
                        title="Add New Folder"
                        onClose={handleAddNewFolderClickClose}
                      >
                        <Form onSubmit={submitHandler}>
                          <FormInput
                            label="Folder Name"
                            name="FolderName"
                            id="FolderName-inline"
                            fluid
                            required
                            maxLength={40}
                            value={newFolderName}
                            onChange={(value) =>
                              SetNewFolderName(value.target.value)
                            }
                          />
                          <DialogActionsBar>
                            <button
                              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                              onClick={addNewFolderSubmitClickHandler}
                              disabled={isValidFileName === false}
                            >
                              {" "}
                              Submit
                            </button>
                            <button
                              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                              onClick={handleAddNewFolderClickClose}
                            >
                              {" "}
                              Close
                            </button>
                          </DialogActionsBar>
                        </Form>
                      </Dialog>
                    )}
                  </div>
    </div>
  );
            
            }

export default FileManager;
